import React, { useMemo } from 'react';

import { DocumentController } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';

import { GrnFactoryCheck } from '../../entities';
import useInstructionsText from '../../hooks/useInstructionsText';

const CHOSEN_FILES = [
  'seller_guarantee',
  'circumstances_assurance',
  'spouse_consent',
  'dkp'
];

const CHOSEN_FILES_NAMES = {
  seller_guarantee: 'Гарантийное письмо',
  circumstances_assurance: 'Договор купли-продажи (шаблон)',
  spouse_consent: 'Согласие супруга(и) / Отсутствие супруга(и)',
  dkp: 'Договор купли-продажи (подписан)'
};

const FreedomBank: React.FC = () => {
  const { selectedBank, attachedFiles } = useAppSelector(
    (state) => state.financingStep
  );

  useInstructionsText();

  const files = useMemo(() => {
    if (!attachedFiles) return [];
    return attachedFiles.filter((item) => CHOSEN_FILES.includes(item.type));
  }, [attachedFiles]);

  return (
    <div className="financing-step__form">
      {files
        ? files.map((file) => (
            <React.Fragment key={file.type}>
              <DocumentController
                fileLink={file.uuid}
                title={
                  CHOSEN_FILES_NAMES[
                    file.type as keyof typeof CHOSEN_FILES_NAMES
                  ]
                }
                downloadable
              />
              {file.type === 'seller_guarantee' && (
                <GrnFactoryCheck
                  grnFileLink={file.link}
                  grnFileType={file.type}
                />
              )}
            </React.Fragment>
          ))
        : selectedBank?.status.code === 'financed' && (
            <p className="financing-step__no-documents">Нет документов</p>
          )}
    </div>
  );
};

export default FreedomBank;
